// extracted by mini-css-extract-plugin
export default {"sidebar":"style_sidebar__GjgXa","trigger":"style_trigger__dgzpa","logo":"style_logo__8LUVi","mobile":"style_mobile__acQlN","menu":"style_menu__Klozd","icon":"style_icon__TkcEf"};